import { translate as t } from '@thoughtspot/i18n';
import { SortOptionFieldName, SortOptionOrder, Users__AccountStatus, } from "../../../../services/generated/graphql-types";
export var UserStateTransition;
(function (UserStateTransition) {
    UserStateTransition["REACTIVATE"] = "reactivate";
    UserStateTransition["UNLOCK"] = "unlock";
    UserStateTransition["UNSUSPEND"] = "unsuspend";
})(UserStateTransition || (UserStateTransition = {}));
export var UserAccountStatus;
(function (UserAccountStatus) {
    UserAccountStatus["ACTIVE"] = "ACTIVE";
    UserAccountStatus["INACTIVE"] = "INACTIVE";
    UserAccountStatus["PENDING"] = "PENDING";
    UserAccountStatus["LOCKED"] = "LOCKED";
    UserAccountStatus["SUSPENDED"] = "SUSPENDED";
    UserAccountStatus["EXPIRED"] = "EXPIRED";
})(UserAccountStatus || (UserAccountStatus = {}));
export var ListActionTypeV2;
(function (ListActionTypeV2) {
    ListActionTypeV2["VIEW_DETAILS"] = "viewDetails";
    ListActionTypeV2["EDIT"] = "edit";
    ListActionTypeV2["DELETE"] = "delete";
    ListActionTypeV2["EXPORT"] = "export";
    ListActionTypeV2["RESEND_ACTIVATION_MAIL"] = "resendActivationMail";
    ListActionTypeV2["UNLOCK"] = "unlockUser";
    ListActionTypeV2["UNSUSPEND"] = "unsuspendUser";
    ListActionTypeV2["RESET_PASSWORD"] = "resetPassword";
    ListActionTypeV2["RESET_MFA"] = "resetMfa";
})(ListActionTypeV2 || (ListActionTypeV2 = {}));
export var UserAuthType;
(function (UserAuthType) {
    UserAuthType["LOCAL_USER"] = "LOCAL_USER";
    UserAuthType["SAML_USER"] = "SAML_USER";
    UserAuthType["OIDC_USER"] = "OIDC_USER";
    UserAuthType["LDAP_USER"] = "LDAP_USER";
})(UserAuthType || (UserAuthType = {}));
export const DEFAULT_BATCH_SIZE = 20;
export const SEARCH_DEBOUNCE_MS = 300;
export const getDefaultUserListParams = () => ({
    name_pattern: undefined,
    record_offset: 0,
    record_size: DEFAULT_BATCH_SIZE,
    sort_options: {
        field_name: SortOptionFieldName.Name,
        order: SortOptionOrder.Asc,
    },
});
export var ActiveModal;
(function (ActiveModal) {
    ActiveModal["NONE"] = "none";
    ActiveModal["DELETE"] = "delete";
    ActiveModal["EXPORT"] = "export";
    ActiveModal["ADD_TO_GROUPS"] = "addToGroups";
    ActiveModal["ADD_TO_ORG"] = "addToOrg";
    ActiveModal["RESET_PASSWORD"] = "resetPassword";
    ActiveModal["USER_DETAILS"] = "userDetails";
    ActiveModal["CREATE_USER"] = "createUser";
    ActiveModal["EDIT_USER"] = "editUser";
    ActiveModal["SETTINGS"] = "settings";
})(ActiveModal || (ActiveModal = {}));
export var V2TranslationKeys;
(function (V2TranslationKeys) {
    V2TranslationKeys["PAGE_TITLE"] = "metadataListPage.users.title";
    V2TranslationKeys["ADD_USER"] = "users.v2.addNewUser";
    V2TranslationKeys["IMPORT_USERS"] = "users.v2.importUsers";
    V2TranslationKeys["DELETE"] = "DELETE";
    V2TranslationKeys["EXPORT"] = "EXPORT";
    V2TranslationKeys["EDIT"] = "EDIT";
    V2TranslationKeys["CANCEL"] = "Cancel";
    V2TranslationKeys["CLOSE"] = "CLOSE";
    V2TranslationKeys["CONFIRM_DELETE"] = "CONFIRM_DELETE";
    V2TranslationKeys["SEARCH_PLACEHOLDER"] = "cirrus.metadata.search.placeHolder";
    V2TranslationKeys["NO_MATCH"] = "NO_MATCH_MSG";
    V2TranslationKeys["NO_RESULTS_TITLE"] = "home.library.search.noResultsFound.title";
    V2TranslationKeys["NO_RESULTS_DESC"] = "home.library.search.noResultsFound.description";
    V2TranslationKeys["ADD_TO_GROUPS"] = "users.list.modal.ADD_TO_GROUPS";
    V2TranslationKeys["ADD_TO_ORG"] = "adminUI.tooltip.ADD_USER_TO_ORG";
    V2TranslationKeys["RESET_PASSWORD"] = "reset.password";
    V2TranslationKeys["RESET_MFA"] = "users.moreOptions.resetMFA";
    V2TranslationKeys["RESET_PASSWORD_WARNING"] = "otp.warning";
    V2TranslationKeys["GENERATE_PASSWORD"] = "generate.password";
    V2TranslationKeys["OTP_GENERATION_FAILED"] = "otp.failed";
    V2TranslationKeys["OTP_GENERATED_SUCCESS"] = "otp.generated.success";
    V2TranslationKeys["DONE"] = "Done";
    V2TranslationKeys["COPY"] = "copy";
    V2TranslationKeys["COPIED"] = "settings.copied";
    V2TranslationKeys["COL_NAME"] = "groups.colHeader.groupName";
    V2TranslationKeys["COL_GROUPS"] = "adminUI.captions.MANAGE_GROUPS_TAB";
    V2TranslationKeys["COL_ORGS"] = "adminUI.captions.ORGS_TAB";
    V2TranslationKeys["COL_CREATED"] = "metadataListPage.captions.CREATED";
    V2TranslationKeys["COL_STATUS"] = "metadataListPage.captions.ACCOUNT_ACTIVATION";
    V2TranslationKeys["COL_ACTIONS"] = "users.v2.colHeader.actions";
    V2TranslationKeys["COL_MORE_OPTIONS"] = "roles.colHeader.moreOptions";
    V2TranslationKeys["STATUS_ACTIVE"] = "users.v2.status.active";
    V2TranslationKeys["STATUS_DEACTIVATED"] = "users.v2.status.deactivated";
    V2TranslationKeys["STATUS_PENDING"] = "users.v2.status.pending";
    V2TranslationKeys["STATUS_LOCKED"] = "users.v2.status.locked";
    V2TranslationKeys["STATUS_SUSPENDED"] = "users.v2.status.suspended";
    V2TranslationKeys["STATUS_EXPIRED"] = "users.v2.status.expired";
    V2TranslationKeys["AUTH_LOCAL"] = "LOCAL";
    V2TranslationKeys["N_MORE"] = "users.v2.nMore";
    V2TranslationKeys["USER_DETAILS_TITLE"] = "users.v2.details.title";
    V2TranslationKeys["USER_DETAILS_STATUS"] = "metadataListPage.captions.ACCOUNT_ACTIVATION";
    V2TranslationKeys["USER_DETAILS_USER_SINCE"] = "users.v2.details.userSince";
    V2TranslationKeys["USER_DETAILS_USER_TYPE"] = "users.v2.details.userType";
    V2TranslationKeys["USER_DETAILS_ORGS"] = "adminUI.captions.ORGS_TAB";
    V2TranslationKeys["USER_DETAILS_GROUPS"] = "adminUI.captions.MANAGE_GROUPS_TAB";
    V2TranslationKeys["EDIT_USER_TITLE"] = "users.list.modal.editUser";
    V2TranslationKeys["EDIT_CREDENTIALS_STEP"] = "users.modalTabLinkLabel.editCredentials";
    V2TranslationKeys["EDIT_SUCCESS"] = "users.wizard.toast.editSuccess";
    V2TranslationKeys["SAVE"] = "Save";
    V2TranslationKeys["ARIA_SETTINGS"] = "users.v2.aria.settings";
    V2TranslationKeys["ARIA_MORE_OPTIONS"] = "users.v2.aria.moreCreateOptions";
    V2TranslationKeys["DELETE_SUCCESS"] = "msg_code.1215.summary";
    V2TranslationKeys["UPDATE_SUCCESS"] = "msg_code.1207.summary";
    V2TranslationKeys["UPDATE_MULTIPLE_SUCCESS"] = "msg_code.12078.summary";
    V2TranslationKeys["ADD_SUCCESS"] = "msg_code.1203.summary";
    V2TranslationKeys["EXPORT_LIMIT_ERROR"] = "principal.export.error.maxLimit";
    V2TranslationKeys["ACTIVATION_MAIL_SENT"] = "adminUI.messages.ACTIVATION_MAIL_SENT_SUCCESS";
    V2TranslationKeys["ACTIVATION_MAIL_ERROR"] = "adminUI.messages.ACTIVATION_MAIL_SENT_ERROR";
    V2TranslationKeys["RESET_MFA_SUCCESS"] = "msg_code.990707.summary";
    V2TranslationKeys["RESET_MFA_ERROR"] = "err_code.990707.summary";
    V2TranslationKeys["ADD_FILTER"] = "liveboardEditHeader.button.addFilter";
    V2TranslationKeys["CLEAR_ALL"] = "Clear_all";
    V2TranslationKeys["CLEAR_SELECTION"] = "Clear_selection";
    V2TranslationKeys["SELECT"] = "Select";
    V2TranslationKeys["LOADING"] = "LOADING_MSG";
})(V2TranslationKeys || (V2TranslationKeys = {}));
export var TableColumnId;
(function (TableColumnId) {
    TableColumnId["NAME"] = "userName";
    TableColumnId["GROUPS_OR_ORGS"] = "groupsOrOrgs";
    TableColumnId["CREATED"] = "userCreated";
    TableColumnId["STATUS"] = "userState";
    TableColumnId["ACTIONS"] = "moreOption";
})(TableColumnId || (TableColumnId = {}));
export const SORT_KEY_MAP = {
    [TableColumnId.NAME]: SortOptionFieldName.Name,
    [TableColumnId.CREATED]: SortOptionFieldName.Created,
};
export var UserFilterKey;
(function (UserFilterKey) {
    UserFilterKey["GROUPS"] = "groups";
    UserFilterKey["ORGS"] = "orgs";
    UserFilterKey["STATUS"] = "status";
})(UserFilterKey || (UserFilterKey = {}));
export const STATUS_FILTER_OPTIONS = [
    Users__AccountStatus.Active,
    Users__AccountStatus.Inactive,
    Users__AccountStatus.Pending,
    Users__AccountStatus.Locked,
];
export const STATUS_LABEL_KEYS = {
    [Users__AccountStatus.Active]: V2TranslationKeys.STATUS_ACTIVE,
    [Users__AccountStatus.Inactive]: V2TranslationKeys.STATUS_DEACTIVATED,
    [Users__AccountStatus.Pending]: V2TranslationKeys.STATUS_PENDING,
    [Users__AccountStatus.Locked]: V2TranslationKeys.STATUS_LOCKED,
    [Users__AccountStatus.Suspended]: V2TranslationKeys.STATUS_SUSPENDED,
    [Users__AccountStatus.Expired]: V2TranslationKeys.STATUS_EXPIRED,
};
export const getStatusDisplayLabel = (status) => {
    const labels = {
        [UserAccountStatus.ACTIVE]: t(V2TranslationKeys.STATUS_ACTIVE),
        [UserAccountStatus.INACTIVE]: t(V2TranslationKeys.STATUS_DEACTIVATED),
        [UserAccountStatus.PENDING]: t(V2TranslationKeys.STATUS_PENDING),
        [UserAccountStatus.LOCKED]: t(V2TranslationKeys.STATUS_LOCKED),
        [UserAccountStatus.SUSPENDED]: t(V2TranslationKeys.STATUS_SUSPENDED),
        [UserAccountStatus.EXPIRED]: t(V2TranslationKeys.STATUS_EXPIRED),
    };
    return labels[status] || status;
};
export const getAuthTypeLabel = (userType) => {
    switch (userType) {
        case UserAuthType.LOCAL_USER:
            return t(V2TranslationKeys.AUTH_LOCAL);
        case UserAuthType.SAML_USER:
            return 'SAML';
        case UserAuthType.OIDC_USER:
            return 'OIDC';
        case UserAuthType.LDAP_USER:
            return 'LDAP';
        default:
            return userType;
    }
};
//# sourceMappingURL=constants.js.map